import dayjs from "dayjs";

interface DateFilterBadgesProps {
	onDateRangeSelect: (dateFrom: string, dateTo: string) => void;
}

const DateFilterBadges = ({ onDateRangeSelect }: DateFilterBadgesProps) => {
	const handleBadgeClick = (rangeType: string) => {
		const today = dayjs();
		let dateFrom: string;
		let dateTo: string;

		switch (rangeType) {
			case "last30days":
				dateFrom = today.subtract(30, "days").toISOString();
				dateTo = today.toISOString();
				break;
			case "lastmonth":
				dateFrom = today
					.subtract(1, "month")
					.startOf("month")
					.toISOString();
				dateTo = today.subtract(1, "month").endOf("month").toISOString();
				break;
			case "ytd":
				dateFrom = today.startOf("year").toISOString();
				dateTo = today.toISOString();
				break;
			case "lastyear":
				dateFrom = today
					.subtract(1, "year")
					.startOf("year")
					.toISOString();
				dateTo = today.subtract(1, "year").endOf("year").toISOString();
				break;
			default:
				return;
		}

		onDateRangeSelect(dateFrom, dateTo);
	};

	const presets = [
		{ label: "Last 30 days", key: "last30days" },
		{ label: "Last month", key: "lastmonth" },
		{ label: "YTD", key: "ytd" },
		{ label: "Last year", key: "lastyear" },
	];

	return (
		<div className="flex flex-wrap gap-1.5 w-full">
			{presets.map((preset) => (
				<button
					key={preset.key}
					onClick={() => handleBadgeClick(preset.key)}
					className="px-3 md:px-2.5 py-1 md:py-[3px] border border-[rgba(148,163,184,0.25)] bg-transparent text-foreground rounded-md cursor-pointer text-xs md:text-[11px] font-medium transition-all duration-150 whitespace-nowrap leading-[1.4] hover:border-primary hover:bg-primary/5 hover:shadow-[0_0_8px_rgba(255,97,97,0.1)] active:scale-[0.98]"
				>
					{preset.label}
				</button>
			))}
		</div>
	);
};

export default DateFilterBadges;
